export default "__VITE_ASSET__D10qitix__"